import React, { useState, useEffect, Suspense } from "react";
import { Intl } from "@/model/index";
import { Link } from "react-router-dom";
import { Spin, Breadcrumb, Row, Col, Button, Table, Modal, Divider } from "antd";
import { myAutoInvestHistoryList } from "@/services/request";
import styles from "./Savings.module.less";
import {
  numberToThousands,
  decimalPointNoMoreX,
  convertUSD2USDC,
  transformTime,
  resetRate
} from "@/utils";
import { Automatice_Investment_History } from "@/config/constants";

interface IProps {}

const WithEmptyContent = React.lazy(
  () => import(/* webpackChunkName: "WithEmptyContent" */ "@/components/emptyContent/EmptyContent")
);

export function InvestmentHistory(props: IProps) {
  const intl: Intl = window.__intl__.messages;
  const loadMore = intl["button.loadMore"];
  const location_text: string = intl["kyc.certify.location"];
  const date_text = intl["column.date"];
  const number_text = intl["column.number"];
  const status_text = intl["column.status"];
  const details_text = intl["column.details"];
  const denomintaion_text: string = intl["savings.automatic.modal.denomintaion"];
  const price_text: string = intl["savings.automatic.modal.price"];
  const amount_text: string = intl["savings.automatic.modal.amount"];
  const breadcrumb_text: string = intl["savings.automatic.my.title"];
  const breadcrumb2_text: string = intl["savings.automatic.history.btn"];
  const comfirmTime_text: string = intl["savings.automatic.history.Comfirm.time"];
  const TxID_text: string = intl["savings.automatic.history.TxID"];

  const contractsId = window?.__history__?.location?.state?.id || null;

  interface ModalInfo {
    amount: number | string;
    subscribeDetails: any[];
    payCurrency: string;
    modified: number | null;
    feeRate: number | null;
    fee: number | null;
    contractId: string;
    status: number | null;
  }
  const modalInfo: ModalInfo = {
    amount: "",
    subscribeDetails: [],
    payCurrency: "",
    modified: null,
    feeRate: null,
    fee: null,
    contractId: "",
    status: null
  };
  const [loading, setLoading] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [dataSource, setDataSource] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [currentInfo, setCurrentInfo] = useState<ModalInfo>(modalInfo);

  useEffect(() => {
    getInitData();
  }, []);
  // 初始化数据,
  const getInitData: () => void = async () => {
    console.log(window?.__history__?.location?.state?.id);
    const param = {
      limit: 10,
      nextToken: nextToken,
      contractId: contractsId
    };
    setLoading(true);
    myAutoInvestHistoryList(param)
      .then((res) => {
        if (res?.code == "0") {
          setDataSource(
            dataSource.length > 0
              ? dataSource.concat(res.data?.investmentOperateLogs)
              : res.data?.investmentOperateLogs
          );
          setNextToken(res.data?.nextToken);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: date_text,
      dataIndex: "modified",
      render: (record) => <span>{transformTime(record)}</span>
    },
    {
      title: number_text,
      dataIndex: "contractName",
      render: (record) => <span>{record}</span>
    },
    {
      title: status_text,
      dataIndex: "status",
      render: (record) => <span>{Automatice_Investment_History[record]}</span>
    },
    {
      title: details_text,
      render: (record, row) => (
        <Button className={styles.actionBtn} onClick={() => getRateInfo(row)}>
          {intl["button.view"]}
        </Button>
      )
    }
  ];

  //重构数据结构 获取每个币种的百分比 @后端接口 可优化
  const getRateInfo = (info) => {
    const newInfo = { ...info };
    const rateList = resetRate(newInfo?.investmentProportion?.currencyProportion);
    newInfo.subscribeDetails?.forEach((item, index) => {
      const currentPercent = rateList?.find((e) => e?.denomintaion === item?.currency)?.percent;
      item.percent = currentPercent;
    });
    setCurrentInfo(newInfo);
    handleChangeVisible();
  };

  const handleChangeVisible = () => {
    setVisible(!visible);
  };

  return (
    <section className={styles.investmentHistory}>
      <Breadcrumb>
        <Breadcrumb.Item>{location_text}: </Breadcrumb.Item>
        <Breadcrumb.Item
          onClick={() => {
            window?.__history__?.goBack();
          }}>
          <span style={{ cursor: "pointer" }}>{breadcrumb_text}</span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{breadcrumb2_text}</Breadcrumb.Item>
      </Breadcrumb>
      <div className={styles.container}>
        <p className={styles.title}>{breadcrumb2_text}</p>
        <Suspense
          fallback={<div className={styles.marketsCard + " middleAlign"}>{/* <Spin /> */}</div>}>
          <WithEmptyContent showEmpty={true}>
            <Spin spinning={loading}>
              <Table
                className={styles.table}
                rowKey={(record) => record?.id}
                bordered={false}
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                rowClassName={styles.sales}
              />
              {nextToken && dataSource.length >= 10 && (
                <div className={styles.loadMore} onClick={() => getInitData()}>
                  {loadMore}
                </div>
              )}
            </Spin>
          </WithEmptyContent>
        </Suspense>
        <Modal
          wrapClassName={styles.modal}
          title={"Automatic Investment Plan"}
          visible={visible}
          width={600}
          destroyOnClose={true}
          footer={null}
          onCancel={handleChangeVisible}>
          <div className={styles.automaticModal}>
            <p style={{ marginBottom: 16 }}>Amount</p>
            <p className={styles.amountSum}>
              {numberToThousands(decimalPointNoMoreX(currentInfo?.amount))}{" "}
              {convertUSD2USDC(currentInfo.payCurrency)}
            </p>
            {currentInfo.status == 3 && ( //PROCESSING(2)：处理中，CONFIRMED(3)：已确认 ，FAILED(11)：失败
              <div>
                <Divider />
                <div className={styles.rateArea}>
                  <Row className={styles.topTitle}>
                    <Col span={8}>
                      <p>{denomintaion_text}</p>
                    </Col>
                    <Col span={8}>
                      <p>{price_text}</p>
                    </Col>
                    <Col span={8}>
                      <p>{amount_text}</p>
                    </Col>
                  </Row>
                  {currentInfo?.subscribeDetails &&
                    currentInfo?.subscribeDetails.length > 0 &&
                    currentInfo?.subscribeDetails.map((item, index) => {
                      return (
                        <Row key={index} className={styles.topContent}>
                          <Col span={8}>
                            <p>{`${item.currency} (${item.percent})`}</p>
                          </Col>
                          <Col span={8}>
                            <p>
                              {
                                //SUBSCRIBE_START(0):开始认购,SUBSCRIBE_CONFIRMED(1):认购完成,SUBSCRIBE_FAILED(2):认购失败
                                //DISPENSE_START(10):开始分配,DISPENSE_CONFIRMED(11):分配完成,DISPENSE_FAILED(12):分配失败
                                item.status == 11
                                  ? `${item.avgPrice} ${convertUSD2USDC(item.quoteCurrency)}`
                                  : "-"
                              }
                            </p>
                          </Col>
                          <Col span={8}>
                            <p>
                              {item.status == 11
                                ? `${numberToThousands(
                                    decimalPointNoMoreX(item?.amount)
                                  )} ${convertUSD2USDC(item.currency)}`
                                : "-"}
                            </p>
                          </Col>
                        </Row>
                      );
                    })}
                </div>
              </div>
            )}
            <Divider />
            <div className={styles.bottomArea}>
              <p>
                <span className={styles.bottonInfoKey}>{comfirmTime_text}</span>
                <span className={styles.bottonInfoValue}>
                  {transformTime(currentInfo.modified)}
                </span>
              </p>
              <p>
                <span className={styles.bottonInfoKey}>{`Fee(${(currentInfo.feeRate * 100).toFixed(
                  2
                )}%)`}</span>
                <span className={styles.bottonInfoValue}>
                  {decimalPointNoMoreX(currentInfo.fee)} {convertUSD2USDC(currentInfo.payCurrency)}
                </span>
              </p>
              <p>
                <span className={styles.bottonInfoKey}>{TxID_text}</span>
                <span className={styles.bottonInfoValue}>{currentInfo.contractId}</span>
              </p>
            </div>
          </div>
        </Modal>
      </div>
    </section>
  );
}

export default InvestmentHistory;
